import { format, startOfMonth, subMonths } from 'date-fns';
import { FileDown, List } from 'lucide-react';
import React from 'react';

import { MonthPicker } from '@components/date-picker';
import { Button } from '@components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@components/ui/card';

import { PastExportsDialog } from './past-exports-dialog';
import { useLicensesExportStore } from './store';

const LicensesExport = () => {
    const [date, setDate] = React.useState<Date | null>(null);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const { list, trigger, refresh } = useLicensesExportStore();

    const onGenerate = () => {
        if (date) {
            trigger.request([format(date, 'yyyy-MM')]);
        }
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle>Licenses Export</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-wrap items-end gap-3">
                <MonthPicker
                    label="Year and Month"
                    className="w-56"
                    minDate={new Date('2020-04-01')}
                    maxDate={startOfMonth(subMonths(new Date(), 1))}
                    value={date}
                    onChange={setDate}
                    clearable
                />
                <Button
                    disabled={!date || trigger.loading}
                    loading={trigger.loading}
                    onClick={onGenerate}
                >
                    <FileDown />
                    Generate
                </Button>
                <Button variant="outline" onClick={() => setDialogOpen(true)}>
                    <List />
                    View exports
                </Button>
            </CardContent>
            <PastExportsDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                list={list}
                refresh={refresh}
            />
        </Card>
    );
};

export default LicensesExport;
